import ButtonGroup from "@visa/vds/button-group";
import ButtonText from "@visa/vds/button-text";
import { default as Dialog, default as dialog } from "@visa/vds/dialog";
import DialogCardBody from "@visa/vds/dialog-card-body";
import DialogCardFooter from "@visa/vds/dialog-card-footer";
import DialogCardHead from "@visa/vds/dialog-card-head";
import DialogCardHeadTitle from "@visa/vds/dialog-card-head-title";
import Fieldset from "@visa/vds/fieldset";
import Form from "@visa/vds/form";
import FormControl from "@visa/vds/form-control";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { FormHelper } from "../../../../_helpers/FormHelper";
import MCSControlInput from "../../../../components/MCSControlInput";

const TagDialog = (props) => {
  const { control, handleSubmit, getValues, reset } = useForm({
    tag: props.tag,
  });

  const [formData, setFormData] = useState(getValues());
  const updateFormData = () => setFormData(getValues());

  const onSubmit = () => {
    let updateDto = formData;
    updateDto.name = updateDto.name.trim();
    props.handleClickSave(props.alertObj, updateDto);
  };

  const isExist = (name) => {
    let tag = props.tagList.filter((i) => {
      return i.name === name && i.id !== props.tag.id;
    });
    return !(tag && tag.length > 0);
  };

  useEffect(() => {
    reset(props.tag);
  }, [props.tag]);

  return (
    <Dialog
      aria-describedby="dialog-description"
      open={props.dialog.open}
      titleId="dialog-title"
    >
      <DialogCardHead style={{ width: "30vw" }}>
        <DialogCardHeadTitle id="dialog-title">
          {props.tag.id === 0 ? "Add New" : "Edit"}
        </DialogCardHeadTitle>
      </DialogCardHead>

      <DialogCardBody id="dialog-description">
        <Form>
          <Fieldset>
            <FormControl>
              <MCSControlInput
                name="name"
                label="Tag Name"
                maxLength="50"
                control={control}
                handleChange={updateFormData}
                rules={{
                  required: true,
                  maxLength: 50,
                  validate: {
                    isExist: (v) =>
                      isExist(v) || "The tag name already exists.",
                    isEmpty: (v) =>
                      FormHelper.isStringBlank(v) ||
                      "The field cannot be blank",
                  },
                }}
              />
            </FormControl>
          </Fieldset>
        </Form>
      </DialogCardBody>
      <DialogCardFooter>
        <ButtonGroup direction="right">
          <ButtonText
            colorScheme="primary"
            type="submit"
            onClick={handleSubmit(onSubmit)}
          >
            Save
          </ButtonText>
          <ButtonText
            colorScheme="secondary"
            onClick={() => {
              props.setDialog({ ...dialog, open: !props.dialog.open });
              props.setTag({ id: 0, name: "" });
            }}
          >
            Cancel
          </ButtonText>
        </ButtonGroup>
      </DialogCardFooter>
    </Dialog>
  );
};
export default TagDialog;
